import axios from "axios";

export default async function getAPIResponse(endpoint, data = {}, method = "get") {
	var response = null;
	try {
		response = await axios({
			method: method,
			url: `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
			data: data,
		});
		return response.data;
	} catch (error) {
        return null;
	}
}
